<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.defaultEncoder' : 'misc.edition.defaultEncoder') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="defaultEncoderForm" *ngIf="defaultEncoderForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="defaultEncoderForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12">
        <div class="form-field col-12">
          <label>{{'attribute.commandsSchema' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <json-editor
            #commandsSchemaEditor
            [options]="jsonEditorService.buildFormEditorOptions()"
            formControlName="commandsSchema"
          ></json-editor>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancel()"
        pButton
        class="p-button-danger ml-2"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="defaultEncoderForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!defaultEncoderForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistDefaultEncoderData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
